<template>
  <div>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      :border="border"
      :stripe="stripe"
      :height="height"
      :max-height="maxHeight"
      size="small"
      :show-header="showHeader"
      :header-cell-style="{
        'background-color': '#84aace4a',
        color: '#343333',
        'text-align': 'center',
      }"
      :cell-style="{ 'text-align': 'center' }"
      :row-class-name="rowClassName"
      @selection-change="handleSelectionChange"
    >
    <el-table-column type="selection" width="55" v-if="isSelection"></el-table-column> 
    <el-table-column label="序号" type="index" width="45" v-if="isSerialNumber"></el-table-column>
      <!-- 动态列 -->
      <el-table-column
        v-for="(column,index) in columns"
        :key="index"
        :prop="column.prop"
        :label="column.label"
        :width="column.width"
        :min-width="column.minWidth"
        :fixed="column.fixed"
        :sortable="column.sortable"
        :formatter="column.formatter"
        :show-overflow-tooltip="column.showOverflowTooltip"
      >
        <template #default="{ row }" v-if="column.slot">
          <slot
            :name="column.slot"
            :row="row"
          ></slot>
        </template>      
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column
        v-if="showOperationColumn"
        label="操作"
        :width="operationColumnWidth"
        :fixed="operationColumnFixed"
      >
        <template #default="{ row }">
          <slot
            name="operation"
            :row="row"
          ></slot>
        </template>
      </el-table-column>
    </el-table>
 
    <!-- 分页 -->
    <el-pagination
      v-if="showPagination"
      style="margin-top: 16px; text-align: right"
      :current-page="currentPage"
      :page-size="pageSize"
      :page-sizes="pageSizes"
      :total="total"
      layout="total, sizes, prev, pager, next"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></el-pagination>
  </div>
</template>
<script>
export default {
  props: {
    // 表格数据
    tableData: {
      type: Array,
      required: true,
    },
    // 列配置
    columns: {
      type: Array,
      required: true,
    },
    // 是否显示边框
    border: {
      type: Boolean,
      default: false,
    },
    // 是否显示斑马纹
    stripe: {
      type: Boolean,
      default: false,
    },
    // 表格高度
    height: {
      type: [String, Number],
      default: null,
    },
    // 表格最大高度
    maxHeight: {
      type: [String, Number],
      default: null,
    },
    // 是否显示表头
    showHeader: {
      type: Boolean,
      default: true,
    },
    // 是否高亮当前行
    highlightCurrentRow: {
      type: Boolean,
      default: false,
    },
    // 是否显示操作列
    showOperationColumn: {
      type: Boolean,
      default: false,
    },
    // 操作列宽度
    operationColumnWidth: {
      type: [String, Number],
      default: "130",
    },
    // 操作列是否固定
    operationColumnFixed: {
      type: [String, Boolean],
      default: false,
    },
    // 是否显示分页
    showPagination: {
      type: Boolean,
      default: false,
    },
    // 当前页码
    currentPage: {
      type: Number,
      default: 1,
    },
    // 每页显示条数
    pageSize: {
      type: Number,
      default: 10,
    },
    // 每页条数选项
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
    // 总条数
    total: {
      type: Number,
      default: 0,
    },
    // 是否显示选择列
    isSelection: {
      type: Boolean,
      default: false,
    },
    // 是否显示序号列
    isSerialNumber: {
      type: Boolean,
      default: false,
    },
    rowKey: {
      type: String,
      default: "id",
    },
    // 行样式类名函数
    rowClassName: {
      type: Function,
      default: null,
    },
  },
  methods: {
    // 每页条数变化事件
    handleSizeChange(size) {
      this.$emit('size-change', size);
    },
    // 当前页码变化事件
    handleCurrentChange(page) {
      this.$emit('current-change', page);
    },
    handleSelectionChange(val) {
      this.$emit('selection-change', val);
    },
  },
};
</script>
